import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';

type Option = {
  name: string;
  id: string | number;
};

interface GenericDropdownProps {
  label: string;
  value: any;
  options: Option[];
  onChange: (value: string | number) => void;
  id?: string;
  minWidth?: number;
  size?: 'small' | 'medium';
  sx?: any;
  onItemClick?: (value: string | number) => void;
  /** Raise the menu above stacked dialogs (e.g. ConfirmModal at modal+2). */
  menuZIndex?: number;
}

const Dropdown: React.FC<GenericDropdownProps> = ({
  label,
  value,
  options,
  onChange,
  id = 'generic-dropdown',
  minWidth = 200,
  size = 'small',
  sx = {},
  onItemClick,
  menuZIndex,
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    const newValue = event.target.value;
    onChange(newValue);
  };

  return (
    <FormControl
      sx={{
        ml: 2,
        minWidth: {
          xs: '100%',
          sm: minWidth,
        },
        ...sx,
      }}
      size={size}>
      <InputLabel id={`${id}-label`}>{label}</InputLabel>
      <Select
        labelId={`${id}-label`}
        id={id}
        value={value}
        label={label}
        onChange={handleChange}
        MenuProps={
          menuZIndex != null
            ? {
                sx: { zIndex: menuZIndex },
              }
            : undefined
        }>
        {(options || []).map(option => (
          <MenuItem
            key={option.id}
            value={option.id}
            {...(onItemClick
              ? {
                  onClick: () => {
                    // Trigger onItemClick when menu item is clicked, even if it's the same value
                    // This allows handling clicks on already-selected items
                    if (option.id === value) {
                      // Use setTimeout to ensure this fires after Select processes the click
                      setTimeout(() => {
                        onItemClick(option.id);
                      }, 0);
                    }
                  },
                }
              : {})}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default Dropdown;
